// Notification IDs are opaque. Follow the server cursor, or the last row
// when Link is unavailable (for example, hidden by CORS).
export function notificationCursor(link, rows, limit) {
  if (link !== null) {
    for (const part of link.split(",")) {
      const match = part.match(/<([^>]+)>;\s*rel="?next"?/);
      if (match) return new URL(match[1]).searchParams.get("max_id");
    }
    return null;
  }
  return rows.length >= limit ? String(rows.at(-1)?.id || "") || null : null;
}

export function mergeNotificationPages(pages, incoming, pageIndex, size = 20) {
  const anchor = pageIndex > 0 ? pages[pageIndex]?.[0]?.key : null;
  const byKey = new Map();
  for (const item of [...incoming, ...pages.flat()]) {
    if (!byKey.has(item.key)) byKey.set(item.key, item);
  }
  const items = [...byKey.values()];
  const merged = [];
  for (let i = 0; i < items.length; i += size) merged.push(items.slice(i, i + size));
  const anchorIndex = anchor ? items.findIndex(item => item.key === anchor) : -1;
  return {
    pages: merged,
    pageIndex: anchorIndex >= 0 ? Math.floor(anchorIndex / size) : 0,
  };
}
